import { FC, useMemo } from "react";
import { Item, ItemProps } from ".";

interface InputProps extends ItemProps {
    value?: string;
    onChange?: (value?: string) => void;
    placeholder?: string;
    inputClassName?: string;
}
const Input: FC<InputProps> = ({ value, onChange, col, error, label, placeholder, required, itemClassName, readOnly, helper, inputClassName }) => {
    const _inputClassName = useMemo(() => {
        let className = `@app-form-input w-full border px-4 py-2 rounded focus:outline-none focus:border-blue-500`;
        if (Boolean(error)) {
            className += " border-red-500 focus:border-red-500 focus:ring-red-500";
        }
        if (inputClassName) {
            className += ` ${inputClassName}`;
        }
        return className;
    }, [error, inputClassName])
    return <Item col={col} label={label} required={required} error={error} itemClassName={itemClassName} helper={helper}>
        <input
            readOnly={readOnly}
            value={value || ""}
            onChange={e => onChange && onChange(e.currentTarget.value)}
            type="text"
            className={_inputClassName}
            placeholder={placeholder}
        />
    </Item>
}

export default Input;